import { cn } from "@/lib/utils";
import { SpineMotif } from "@/components/brand/SpineMotif";

export const SectionHeading = ({ eyebrow, title, intro, center = false, className = "", as: Tag = "h2", id }) => (
  <div className={cn(center ? "mx-auto max-w-2xl text-center" : "max-w-2xl", className)}>
    {eyebrow && <p className="eyebrow">{eyebrow}</p>}
    <Tag id={id} className="font-heading text-2xl font-bold tracking-tight text-brand-ink sm:text-3xl lg:text-4xl">
      {title}
    </Tag>
    {intro && <p className="mt-4 text-base leading-relaxed text-slate-600 md:text-lg">{intro}</p>}
  </div>
);

export const PageHero = ({ eyebrow, title, intro, children }) => (
  <section className="mesh-hero grain relative overflow-hidden border-b border-white">
    <span className="blob -right-20 -top-16 h-64 w-64 bg-brand-sky/25" aria-hidden="true" />
    <span className="blob -bottom-24 right-1/3 h-56 w-56 bg-brand-lime/25" aria-hidden="true" />
    <SpineMotif className="pointer-events-none absolute right-8 top-6 hidden h-[300px] text-brand-blue/[0.08] md:block" count={12} />
    <div className="container-x relative py-14 md:py-20">
      <div className="max-w-3xl animate-rise">
        {eyebrow && <p className="eyebrow">{eyebrow}</p>}
        <h1 className="font-heading text-4xl font-extrabold tracking-tight text-brand-ink sm:text-5xl lg:text-6xl">{title}</h1>
        {intro && <p className="mt-5 text-base leading-relaxed text-slate-600 md:text-lg">{intro}</p>}
        {children}
      </div>
    </div>
  </section>
);
